import React, { useEffect, useState } from "react";
import { Layout } from "./components/layout";
import { DesktopLayout } from "./components/layout/desktop";
import { BrowserRouter as Router, Route } from "react-router-dom";
import ContactLayout from "./components/layout/articles/contact";
import LearnStrategiesLayout from "./components/layout/articles/strategies";
import TnC from "./components/layout/articles/tnc";
import WhyStrategiesLayout from "./components/layout/articles/why-option-strategies";
import RiskRewardLayout from "./components/layout/articles/risk-reward-ratio";
import BreakEvenLayout from "./components/layout/articles/break-even";
import Nifty from "./components/layout/generator/nifty";
import "./App.scss";
import VirtualTrading from "./components/layout/virtual-trading";
// import KiteAPITrading from './components/layout/kiteAPITrading';
import { initializeDB } from "./data/db";
import Chatbot from "./Ask AI/Chatbot";

import { Fab, Tooltip } from "@mui/material";
import AssistantIcon from '@mui/icons-material/Assistant';

function App() {
  const [showChatbot, setShowChatbot] = useState(false);

  useEffect(() => {
    initializeDB();
  }, []);
  return (
    <>
      <Router>
        <Route exact path="/">
          {(window as any).NativeNewsBridge ? <Layout /> : <Nifty
            indexName="Nifty"
            lotSize={25}
            maxStrikes={3}
            shortMargin={218500}
            marginBenefit={175000}
            dataUrl="NIFTY"
            isIndex={true}
          />}
        </Route>
        <Route exact path="/contact">
          <ContactLayout />
        </Route>
        <Route exact path="/why-option-strategies">
          <LearnStrategiesLayout />
        </Route>
        <Route exact path="/strategies">
          <WhyStrategiesLayout />
        </Route>
        <Route exact path="/risk-reward-ratio">
          <RiskRewardLayout />
        </Route>
        <Route exact path="/break-even">
          <BreakEvenLayout />
        </Route>
        <Route exact path="/nifty">
          <Nifty
            indexName="Nifty"
            lotSize={75}
            maxStrikes={8}
            shortMargin={218500}
            marginBenefit={175000}
            dataUrl="NIFTY"
            isIndex={true}
          />
        </Route>
        <Route exact path="/bank-nifty">
          <Nifty
            indexName="Bank Nifty"
            lotSize={15}
            maxStrikes={10}
            shortMargin={100000}
            marginBenefit={19000}
            dataUrl="BANKNIFTY"
            isIndex={true}
          />
        </Route>
        <Route exact path="/fin-nifty">
          <Nifty
            indexName="Fin Nifty"
            lotSize={40}
            maxStrikes={8}
            shortMargin={100000}
            marginBenefit={18000}
            dataUrl="FINNIFTY"
            isIndex={true}
          />
        </Route>
        <Route exact path="/airtel">
          <Nifty
            indexName="BHARTIARTL"
            lotSize={950}
            maxStrikes={8}
            shortMargin={150000}
            marginBenefit={30000}
            dataUrl="BHARTIARTL"
            isIndex={false}
          />
        </Route>
        <Route exact path="/tnc">
          <TnC></TnC>
        </Route>
        <Route exact path="/virtual-trading">
          <VirtualTrading />
        </Route>
        {/* <Route exact path="/kiteAPITrading">
        <KiteAPITrading />
      </Route> */}
      </Router>
      <div style={{ position: 'fixed', bottom: '50px', right: '20px', zIndex: 1000 }}>
        <Tooltip title="Ask AI" placement="top" arrow>
          <Fab color="primary" aria-label="ask ai" onClick={() => setShowChatbot(!showChatbot)}>
            <AssistantIcon />
          </Fab>
        </Tooltip>
        <div style={{
          position: 'absolute',
          bottom: '80px',
          right: '0px',
          transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
          opacity: showChatbot ? 1 : 0,
          transform: showChatbot ? 'translateY(0)' : 'translateY(20px)',
          pointerEvents: showChatbot ? 'auto' : 'none',
          
        }}>
          <Chatbot />
        </div>
      </div>
    </>
  );
}

export default App;
